
import * as React from 'react';
import Alert from '@payscale/design/lib/alert';
import './editModalFooter.scss';

interface EditModalFooterProps {
    isSending: boolean;
    isSaveError: boolean;
    errorDetails: { [id: string]: string };
    handleSaveClick: () => void;
    handleCancelClick: () => void;
    isFormValid:() => boolean;
    handleErrorBannerClose:() => void;
}

export default class EditModalFooter extends React.Component<EditModalFooterProps, {}> {
    render(): JSX.Element {
        const buttonText = this.props.isSending ? 'Saving...' : 'Save Changes';
        const errorsExist = (!(Object.keys(this.props.errorDetails).filter(key => key !== 'missingUser').length === 0) || !this.props.isFormValid());
        return (
            <div className="nomst-edit-modal-footer">
                <div className="nomst-edit-modal-footer__left-column">
                    {this.renderSubmitErrorMessage()}
                </div>
                <div className="nomst-edit-modal-footer__right-column">
                    <div className="nomst-edit-employee-footer__buttons">
                        <button className="nomst-edit-modal-footer__cancel-button pxl-link" onClick={this.props.handleCancelClick}>
                            Cancel
                        </button>
                        <button
                            onClick={this.props.handleSaveClick}
                            className="nomst-edit-modal-footer__save-button pxl-btn pxl-btn--primary"
                            disabled={this.props.isSending || errorsExist}
                        >
                            {buttonText}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    private renderSubmitErrorMessage(): React.ReactNode {
        if (!this.props.isSaveError) {
            return null;
        }

        return (
            <Alert
                message='Failed to save changes. Try again.'
                level="danger"
                close={true}
                onClickClose={this.props.handleErrorBannerClose}
            />
        );
    }
}
